<template>
  <section
    class="section section-primary is-small animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->
      <div class="content-wrapper">
        <div class="columns is-centered">
          <div
            class="column is-6"
            v-if="!requestsuccess && !requestloading && !requestfail"
          >
            <!-- Login form -->
            <div
              class="flex-card card-overflow raised padding-20 animated preFadeInUp fadeInUp pb-90"
            >
              <div
                class="square-icon-box rounded info mt-20 animated preFadeInUp fadeInUp"
              >
                <div class="icon-box-wrapper">
                  <div class="icon-box">
                    <i class="material-icons">history</i>
                  </div>
                </div>
              </div>
              <div class="animated preFadeInUp fadeInUp pb-90">
                <hr />
                <h1 class="title is-4 pb-10">إعادة المطالبة موبي كاش</h1>

                <b-field label="مركز البيع / الخدمات" label-position="inside">
                  <b-input
                    type="text"
                    size="is-medium"
                    v-model="requestInfo.PosName"
                    name="PosName"
                    v-validate="'required'"
                    placeholder="ادخل الاسم"
                    expanded
                  ></b-input>
                </b-field>

                <span
                  v-show="errors.has('PosName')"
                  class="help is-danger is-centered"
                  >{{ errors.first("PosName") }}</span
                >

                <b-field label="الكائن في">
                  <b-input
                    type="text"
                    size="is-medium"
                    v-model="requestInfo.PosAddress"
                    name="PosAddress"
                    v-validate="'required'"
                    placeholder="ادخل العنوان"
                    expanded
                  ></b-input>
                </b-field>

                <span
                  v-show="errors.has('PosAddress')"
                  class="help is-danger is-centered"
                  >{{ errors.first("PosAddress") }}</span
                >

                <b-field label="قيمة المبلغ">
                  <b-input
                    type="text"
                    v-validate="'required|decimal'"
                    v-model="requestInfo.RequestedAmount"
                    placeholder="ادخل قيمة"
                    size="is-medium"
                    class="is-english"
                    name="RequestedAmount"
                    expanded
                    @input="(event) => (amountValidate = true)"
                  ></b-input>
                </b-field>
                <span
                  v-show="errors.has('RequestedAmount')"
                  class="help is-danger is-centered"
                  >{{ errors.first("RequestedAmount") }}</span
                >
                <span
                  v-show="requestInfo.RequestedAmount <= 0 && amountValidate"
                  class="help is-danger is-centered"
                  >يجب ان تكون القيمة المدخلة أكبر من صفر</span
                >

                <v-date-picker
                  :max-date="new Date()"
                  v-model="requestInfo.PurchasedAt"
                  locale="ar"
                  :popover="{ placement: 'bottom', visibility: 'click' }"
                  :first-day-of-week="1"
                >
                  <b-field
                    label="تاريخ عملية الشراء"
                    size="is-medium"
                    :class="{ 'is-danger': errors.has('PurchasedAt') }"
                  >
                    <b-input
                      type="text"
                      class="is-medium"
                      :value="$root.dateformat(requestInfo.PurchasedAt)"
                      v-validate="'required'"
                      placeholder="تاريخ عملية الشراء"
                      name="PurchasedAt"
                      expanded
                    ></b-input>
                  </b-field>
                </v-date-picker>

                <span
                  v-show="errors.has('PurchasedAt')"
                  class="help is-danger is-centered"
                  >{{ errors.first("PurchasedAt") }}</span
                >
              </div>
              <hr />
              <div class="hero-foot mt-20 mb-20">
                <a
                  class="button is-info is-pulled-left modal-dismiss is-bold is-medium"
                  v-on:click="validateBeforeSubmit()"
                >
                  <b>ارسال</b>
                </a>
              </div>
            </div>
          </div>

          <div
            class="columns is-vcentered has-text-centered mt-90 mb-90"
            v-if="!requestsuccess && requestloading"
          >
            <div class="column">
              <loading
                line-fg-color="#2d3f51"
                size="massive"
                class="margin-100"
                spacing="55"
                text-fg-color="#fff"
                message="الرجاء الإنتظار"
              />
            </div>
          </div>
        </div>

        <div
          class="columns is-vcentered"
          v-if="requestsuccess && !requestloading"
        >
          <div class="column is-6 is-offset-3 mb-90">
            <!-- Login form -->
            <div
              class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
            >
              <div
                class="square-icon-box rounded primary mt-20 animated preFadeInUp fadeInUp"
              >
                <div class="icon-box-wrapper">
                  <div class="icon-box">
                    <i class="material-icons">check</i>
                  </div>
                </div>
              </div>
              <div class="animated preFadeInUp fadeInUp pb-90">
                <hr />
                <h1 class="title is-4 pb-10">
                  تم ارسال طلب {{ requeststring }} بنجاح
                </h1>

                <h1 class="subtitle is-5">
                  سيتم تنبيهك عند الانتهاء من معالجة طلبك
                </h1>

                <hr />
              </div>
            </div>
            <div class="hero-foot has-text-centered mt-40 mt-40">
              <router-link to="/portal">
                <a
                  class="button is-dark btn-align modal-dismiss is-bold is-medium"
                >
                  <b>عودة للرئيسية</b>
                </a>
              </router-link>
            </div>
          </div>
        </div>
        <div class="columns is-vcentered" v-if="requestfail && !requestloading">
          <div class="column is-6 is-offset-3 mb-90">
            <!-- Login form -->
            <div class="flex-card raised padding-20">
              <div class="square-icon-box rounded danger mt-20">
                <div class="icon-box-wrapper">
                  <div class="icon-box">
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </div>
              <div class="animated preFadeInLeft fadeInLeft pb-90">
                <hr />
                <h1 class="title is-4 pb-10">
                  تم فشل ارسال طلب {{ requeststring }}
                </h1>

                <h1 class="subtitle is-5">{{ errormessage }}</h1>

                <!-- 
                <h1 class="subtitle is-5">رجاء المحاولة لاحقاً</h1>-->

                <hr />
              </div>
            </div>
            <div
              class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
            >
              <a
                class="button is-dark btn-align modal-dismiss is-bold is-medium"
                @click="$router.go('-1')"
              >
                <b>العودة</b>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";

export default {
  props: ["requeststring", "requestid", "requesturl"],

  data() {
    return {
      amountValidate: false,
      requestloading: false,
      requestsuccess: false,
      requestfail: false,
      errormessage: "",
      requestInfo: {
        Customer_Id: "",
        PosName: "",
        PosAddress: "",
        RequestedAmount: 0,
        PurchasedAt: new Date(),
      },
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.amountValidate = true;
      this.$validator.validateAll().then((result) => {
        if (result && this.requestInfo.RequestedAmount >= 1) {
          this.send();
          return;
        }
      });
    },
    send() {
      this.requestloading = !this.requestloading;
      console.log(this.requestInfo);
      this.requestInfo.PurchasedAt = this.$root.dateformat(
        this.requestInfo.PurchasedAt
      );
      axios
        .post("refund/mobiCash", this.requestInfo)
        .then((response) => {
          this.$root.kick(response.data.message);
          console.log(response);
          if (response.data.status === "success") {
            this.requestloading = !this.requestloading;
            this.requestsuccess = !this.requestsuccess;

            // alert("request sent successfully");
          } else if (response.data.status === "fail") {
            this.requestloading = !this.requestloading;
            this.requestsuccess = false;
            this.requestfail = true;
            console.log(response.data.message);
            this.errormessage = response.data.message;
            // alert("request fail");
          }
        })
        .catch((error) => {
          this.isLoading = !this.isLoading;
          this.message = true;
        });
    },
  },
  created() {
    this.amountValidate = false;
    this.$validator.localize("ar", {
      messages: arabic.messages,
      attributes: {
        PosName: "مركز البيع / الخدمات",
        PosAddress: "الكائن في",
        RequestedAmount: "قيمة المبلغ",
        PurchasedAt: "تاريخ عملية الشراء",
      },
    });
    var user = JSON.parse(localStorage.getItem("user"));
    moment.locale("en");
    this.requestInfo.Customer_Id = user[1];

    let token = localStorage.getItem("token");
    console.log(this.requestInfo);
  },
};
</script>
